module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/us-c95087e1a852cf730acc3defc2d52724.svg";